<template>
  <form @submit.prevent="replaceDriver()">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="partnerInfoEditModalLabel">
          {{ carInfo?.driver_name ? 'Replace' : 'Add' }} driver for "{{
            carInfo?.license_plate_number
          }}"
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          ref="modalCloseBtn"
        ></button>
      </div>
      <div class="modal-body">
        <h6>
          Present Driver:
          {{ carInfo?.driver_name ? carInfo?.driver_name : 'N/A' }}
        </h6>
        <h6>New Driver: {{ driver?.name }}</h6>
        <div class="form-group" style="margin-top: 5px">
          <label for="">New Driver Phone:</label>
          <input
            type="text"
            class="form-control"
            v-model="formValue.mobile"
            required
          />
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary">Submit</button>
      </div>
    </div>
  </form>
</template>

<script>
import http from '@/config/axios';
import userService from '../../config/axiosUserService';
import moment from 'moment';

export default {
  props: ['baseUrl', 'carInfo'],
  data() {
    return {
      formValue: {
        car_id: null,
        old_driver_code: null,
        driver_code: null,
        user_id: null,
        mobile: null,
        start_date: null,
        end_date: null
      },
      driver: {}
    };
  },
  watch: {
    carInfo: function () {
      this.formValue.car_id = this.carInfo?.car_id;
      this.formValue.user_id = this.carInfo?.user_id;
      this.formValue.old_driver_code = this.carInfo?.driver_code;
    },
    'formValue.mobile': function () {
      this.searchDriverByPhone();
      this.calculateDates();
    }
  },
  methods: {
    resetFormValue() {
      this.formValue.driver_code = null;
      this.formValue.mobile = '';
    },
    calculateDates() {
      var newDate = new Date();
      this.formValue.end_date = moment(newDate).format('YYYY-MM-DD');

      if (newDate.getDay() === 4) {
        newDate.setDate(newDate.getDate() - 1);
      }
      var daysToSub =
        newDate.getDay() > 3 ? newDate.getDay() - 4 : newDate.getDay() + 3;
      const startDate = new Date(
        newDate.setDate(newDate.getDate() - daysToSub)
      );

      this.formValue.start_date = moment(startDate).format('YYYY-MM-DD');
    },
    replaceDriver() {
      if (this.formValue.driver_code) {
        http
          .post('/v2/partners/addOrReplaceDriver', this.formValue)
          .then((response) => {
            if (response.status == 200) {
              this.$emit('refreshPaginationData');
              this.$refs.modalCloseBtn.click();
              this.resetFormValue();
              this.$swal('Success', 'Successfully Saved!', 'success');
            } else {
              this.$swal('Error', 'Something went wrong!', 'error');
            }
          })
          .catch((error) => {
            this.$swal('Error', error.response.data.message, 'error');
            console.log(error);
          });
      } else {
        this.$swal('Warning', 'Please select a driver first!', 'warning');
      }
    },
    searchDriverByPhone() {
      this.driver = {};
      this.formValue.driver_code = null;

      if (
        this.formValue.mobile &&
        (this.formValue.mobile.length == 10 ||
          this.formValue.mobile.length == 11)
      ) {
        let url = `v1/users/search?field=mobile&return=mobile,name,user_code&key=${this.formValue.mobile}`;
        userService
          .get(url)
          .then((response) => {
            let drivers = response.data.data;

            if (drivers && drivers.length > 0) {
              this.driver = drivers[0];
              this.formValue.driver_code = this.driver.user_code;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  }
};
</script>

<style scoped></style>
